module.exports = __webpack_public_path__ + "img/image2.888b15be.png";